export enum GraphvizLayoutType {
  Graphviz_circo = "circo",
  Graphviz_dot = "dot",
  Graphviz_fdp = "fdp",
  Graphviz_sfdp = "sfdp",
  Graphviz_neato = "neato",
  Graphviz_osage = "osage",
  Graphviz_patchwork = "patchwork",
  Graphviz_twopi = "twopi",
  Graphviz_nop = "nop",
  Graphviz_nop2 = "nop2",
}
